import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconClose from './icon-close-white.svg';
import './notification.css';

export default class Notification extends PureComponent{
    componentDidMount(){
        requestAnimationFrame(()=>{
            this.notification.classList.add('animation');
        })
        const {type,hide}=this.props;
        if(type === 'success'){
            this.timeout = setTimeout(this.props.onClose,hide);
        }
    }
    componentWillUnmount(){
        clearTimeout(this.timeout);
    }
    render(){
        let notificationClasses = classNames({
            "super-notification":true,
            [this.props.type]:true
        })
        return (
            <div className={notificationClasses} ref={r=>this.notification=r}>
                <span>{this.props.message}</span>
                <div className="super-notification-close" onClick={this.props.onClose}>
                    <img src={IconClose} height="24" width="24" alt="Close"/>
                </div>
            </div>
        )
    }
}

Notification.propTypes = {
    type:PropTypes.oneOf(['success','error']).isRequired,
    message:PropTypes.string.isRequired,
    hide:PropTypes.number,
    onClose:PropTypes.func
}

Notification.defaultProps = {
    onClose:()=>{},
    hide:3000
}


// WEBPACK FOOTER //
// ./src/components/Notification/index.js